import { inject, injectable } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { DashboardRouter } from '../../../dashboard/types';
import { modules } from '../../modules';

@injectable()
export class DashboardRouterService implements DashboardRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goBack(prevState: { pathname: string; search: string }) {
    this.history.push(prevState);
  }

  goToEventList(role: 'employee' | 'company', query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${role}/${modules.events.basename}`);
      return;
    }

    this.history.push({
      pathname: `/${role}/${modules.events.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToPolicyList(query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${this.role.get()}/${modules.policy.basename}`);
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.policy.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToVacationList(query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${this.role.get()}/${modules.vacations.basename}`);
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.vacations.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToList() {
    this.history.push('/');
  }

  goToWidgetsList() {
    this.history.push('/widgets');
  }

  goToPersonalLinksSettings(widgetId: string) {
    this.history.push(`/widgets/${widgetId}/personal_links`);
  }

  goToNewsWidgetSettings(widgetId: string) {
    this.history.push(`/widgets/${widgetId}/news`);
  }

  goToSurveysSettings(widgetId: string) {
    this.history.push(`/widgets/${widgetId}/surveys`);
  }

  goToSurvey(id: string) {
    this.history.push(`/surveys/${id}`);
  }

  goToExternalWidget(id: string, query?: string) {
    this.history.push(`/external/${id}${query ? `?${query}` : ''}`);
  }

  goToQuickActionsSettings(widgetId: string) {
    this.history.push(`/widgets/${widgetId}/quick_actions`);
  }

  goToUserQuickActionUrl(url: string) {
    window.open(url, '_blank');
  }

  goToHome() {
    this.history.push('/');
  }

  goToPersonalDetail(userId: string) {
    this.history.push(`/personal/${userId}`);
  }

  goToDetailPost(communityId: string, postId: string) {
    window.open(
      `/${modules.feed.basename}/${communityId}/post/${postId}`,
      '_blank',
    );
  }

  goToDetailNews(newsId: string) {
    window.open(`/${modules.news.basename}/${newsId}`, '_blank');
  }
}
